export class LoginRequest {
    partnerCode: string;
    username: string;
    key: string;
    twoFactorCode: string;
    rememberMe = true;
}